import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
          <Footer />
          <WhatsAppFloat />
          <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
